export type LeagueChromeScoreMode = "expanded" | "compact" | "hidden";

export type LeagueChromePolicy = {
  scoreMode: LeagueChromeScoreMode;
  titleDensity: "default" | "compact";
};

const expandedScorePageIDs = new Set(["dailySchedule", "gameLog", "liveGame", "playoffs"]);

export const getLeagueChromePolicy = (pageID: string | undefined): LeagueChromePolicy => {
  const scoreMode: LeagueChromeScoreMode = expandedScorePageIDs.has(pageID ?? "")
    ? "expanded"
    : "hidden";

  return {
    scoreMode,
    titleDensity: scoreMode === "expanded" ? "default" : "compact",
  };
};
